import { fetchSpherePhotos, updateSpherePhoto, deleteSpherePhoto } from '../../services/apiClient.js';
import { photoDownloadName } from '../../utils/photoArchive.js';

// Photos prises sur la page Sillages : même gestion que les photos carte.
// "Pseudo" = légende libre (un ou plusieurs pseudos, "Tous les
// punchliners"), donc sans @ imposé. Miniature légère dans la liste, PNG HD
// au téléchargement.
export function createSpherePhotoDashboardFeature() {
  let rows = [];
  const spherePhotoList    = document.getElementById('spherePhotoList');
  const spherePhotoEmpty   = document.getElementById('spherePhotoEmpty');
  const spherePhotoCardTpl = document.getElementById('spherePhotoCardTpl');

  function createSpherePhotoCard(photo) {
    const frag = spherePhotoCardTpl.content.cloneNode(true);
    const li   = frag.querySelector('.photo-card');

    const imageUrl = `/api/sphere-photos/${photo.id}/image`;

    // L'original pèse plusieurs dizaines de Mo : version web dans la liste.
    li.querySelector('.photo-thumb').src = imageUrl + '?size=thumb';
    const dlLink = li.querySelector('.photo-download');
    dlLink.href  = imageUrl + '?download=1';
    dlLink.setAttribute('download', photoDownloadName({ type: 'sphere', ...photo }));

    // Masquer : retirée d'Escales, gardée en base et sur S3 -- réversible,
    // contrairement à la suppression.
    const btnHide = li.querySelector('.photo-hide');
    function showHidden() {
      li.classList.toggle('photo-card--hidden', photo.hidden);
      btnHide.textContent = photo.hidden ? 'Afficher' : 'Masquer';
      btnHide.title       = photo.hidden ? 'Remettre la photo sur le site' : 'Retirer la photo du site sans la supprimer';
    }
    showHidden();
    btnHide.addEventListener('click', async () => {
      const hidden = !photo.hidden;
      btnHide.disabled = true;
      try {
        const res = await updateSpherePhoto(photo.id, { hidden });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        photo.hidden = hidden;
        showHidden();
      } catch (err) {
        console.error('Erreur masquage photo sphère:', err);
      } finally {
        btnHide.disabled = false;
      }
    });

    li.querySelector('.photo-date').textContent = new Date(photo.createdAt)
      .toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });

    const pseudoEl      = li.querySelector('.dash-pseudo');
    const btnEditPseudo = li.querySelector('.dash-btn--edit-pseudo');

    function showPseudoText() {
      pseudoEl.textContent = photo.pseudo || '—';
      // Liste coupée par "…" dans la carte : en entier au survol.
      pseudoEl.title       = photo.pseudo || '';
      pseudoEl.hidden      = false;
      btnEditPseudo.hidden = false;
    }

    function showPseudoInput() {
      pseudoEl.hidden      = true;
      btnEditPseudo.hidden = true;
      const inp = document.createElement('input');
      inp.type           = 'text';
      inp.className      = 'dash-pseudo-input';
      inp.placeholder    = 'Pseudo(s) ou Tous les punchliners';
      inp.autocapitalize = 'none';
      inp.value          = photo.pseudo || '';
      li.querySelector('.dash-pseudo-row').insertBefore(inp, pseudoEl);

      let committed = false;
      function commit() {
        if (committed) return;
        committed    = true;
        const val    = inp.value.trim();
        inp.remove();
        photo.pseudo = val;
        showPseudoText();
        updateSpherePhoto(photo.id, { pseudo: val }).catch(err => console.error('Erreur légende photo sphère:', err));
      }
      inp.addEventListener('blur', commit);
      inp.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
      });
      inp.focus();
    }

    showPseudoText();
    btnEditPseudo.addEventListener('click', showPseudoInput);

    li.querySelector('.photo-delete').addEventListener('click', async () => {
      li.classList.add('dash-card--removing');
      li.addEventListener('animationend', async () => {
        try {
          await deleteSpherePhoto(photo.id);
          rows = rows.filter(p => p.id !== photo.id);
          li.remove();
          spherePhotoEmpty.hidden = rows.length > 0;
        } catch (err) {
          console.error('Erreur suppression photo sphère:', err);
        }
      }, { once: true });
    });

    li.dataset.id = photo.id;
    return li;
  }

  async function load() {
    try {
      rows = await fetchSpherePhotos({ includeHidden: true });
      spherePhotoList.innerHTML = '';
      spherePhotoEmpty.hidden   = rows.length > 0;
      for (const photo of rows) {
        spherePhotoList.appendChild(createSpherePhotoCard(photo));
      }
    } catch (err) {
      console.error('Erreur chargement photos sphère:', err);
    }
  }

  return { load };
}
